import apiClient from '../client';
import type { Database } from '@/lib/supabase/supabase-types';

type FreelancerProfile = Database['public']['Tables']['freelancer_profiles']['Row'];
type FreelancerProfileInsert = Database['public']['Tables']['freelancer_profiles']['Insert'];
type FreelancerProfileUpdate = Database['public']['Tables']['freelancer_profiles']['Update'];

export const freelancerService = {
  /**
   * Get current user's freelancer profile
   */
  getMyProfile: (): Promise<FreelancerProfile> => 
    apiClient.get<FreelancerProfile>('/profiles/freelancer/me') as unknown as Promise<FreelancerProfile>,
  
  /**
   * Get freelancer profile by ID (public endpoint)
   */
  getProfile: (profileId: string): Promise<FreelancerProfile> => 
    apiClient.get<FreelancerProfile>(`/profiles/freelancer/${profileId}`) as unknown as Promise<FreelancerProfile>,
  
  /**
   * Get current user's freelancer profile ID
   */
  getMyProfileId: (): Promise<{ id: string }> => 
    apiClient.get<{ id: string }>('/profiles/freelancer/me/id') as unknown as Promise<{ id: string }>,
  
  /**
   * Create freelancer profile for current user
   */
  createProfile: (data: Omit<FreelancerProfileInsert, 'user_id'>): Promise<FreelancerProfile> => 
    apiClient.post<FreelancerProfile>('/profiles/freelancer/me', data) as unknown as Promise<FreelancerProfile>,
  
  /**
   * Update current user's freelancer profile
   */
  updateProfile: (data: FreelancerProfileUpdate): Promise<FreelancerProfile> => 
    apiClient.patch<FreelancerProfile>('/profiles/freelancer/me', data) as unknown as Promise<FreelancerProfile>,
  
  /**
   * Get featured freelancer profiles (public endpoint)
   */
  getFeaturedFreelancers: (limit?: number): Promise<FreelancerProfile[]> => 
    apiClient.get<FreelancerProfile[]>('/profiles/freelancer/featured', {
      params: limit ? { limit } : undefined,
    }) as unknown as Promise<FreelancerProfile[]>,
  
  /**
   * Track a profile view
   * Records a view for a freelancer profile. Only authenticated, non-owner users
   * who stay on the page for ≥5 seconds are counted, with 24-hour deduplication.
   */
  trackProfileView: (profileId: string): Promise<{ message: string }> => 
    apiClient.post<{ message: string }>(`/profiles/freelancer/${profileId}/view`) as unknown as Promise<{ message: string }>,
};

